<div class="flex items-center justify-between mt--10">
  <div class="flex items-center mt-8">
    <mat-icon svgIcon="work_outline" class="mr-8"></mat-icon>
    <div class="mat-subtitle-2 mb-0 fs-24 fw-600">{{'JOBS.JOBS' | transloco}}
      <span>({{searchTerm?.length > 0 && searchedResult ? searchedResult.length || 0 : (dataJobs?.length || 0)}})</span>
    </div>
    <div class="ml-16 search-jobs">
      <app-search-filter class="mt-20 ml-20" placeholder="SEARCH.SEARCH" [ngClass]="{'disabled': !envJobResponse || jobLoading}" (changed)="search($event)"></app-search-filter>
    </div>
    <span class="vertical-dash ml-12"></span>
    <button [ngClass]="{'disabled': !(envJobResponse) || jobLoading}" class="flex justify-center items-center context-menu-icon-filter height menu-btn pr-8 pl-8 pt-6 pb-6 ml-12 filter"  (click)="filterColumns()">
      <mat-icon svgIcon="filter_alt" class="mr-4"></mat-icon>
      <span class="fw-500 filters">{{'TENANT_LIST.FILTERS' | transloco}}</span>
    </button>
    </div>
    <div class="flex flex-row gap-3 create-jobs">
    <div class="refresh-circle rounded-full w-32 h-32 flex items-center justify-center cursor-pointer" (click)="refreshClick()">
        <mat-icon svgIcon="refresh" class="icons transition-transform duration-700" [ngClass]="{ 'animate-spin': isRefreshing }"></mat-icon>
    </div>
 <app-environment-paginator [length]="searchedResult?.length" [pageIndex]="pageIndex" [pageSize]="paginationSize" (page)="onPageChange($event)"></app-environment-paginator>    </div>
 </div>
 <div *ngIf="selectedSchedule?.length > 0 || selectedRunbook?.length > 0 || selectedStatus?.length > 0 || filterStartDate && filterEndDate" class="flex flex-row flex-wrap items-center ml-8 mt-6">
      @if (selectedSchedule?.length > 0) {
        <span class="pr-8 fs-16">{{ 'TOOLBAR.SCHEDULE' | transloco }}</span>
      }
      <div class="mr-4 filtered-items flex flex-wrap items-center fs-16 fw-500" *ngIf="selectedSchedule?.length > 0">
               <span *ngFor="let schedule of selectedSchedule" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-2 pb-2 mr-16">
                  {{getScheduleLabel(schedule)}}
                  <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="cancelScheduleFilter(schedule)"></mat-icon>
               </span>
         </div>
          @if (selectedRunbook?.length > 0) {
            <span class="pr-8 fs-16">{{ 'TOOLBAR.RUNBOOK' | transloco }}</span>
          }
         <div class="mr-4 filtered-items flex flex-wrap items-center fs-16 fw-500" *ngIf="selectedRunbook?.length > 0">
               <span *ngFor="let runbook of selectedRunbook" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-2 pb-2 mr-16">
                  {{getRunbookLabel(runbook)}}
                  <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="cancelRunbookFilter(runbook)"></mat-icon>
               </span>
         </div>
          @if (selectedStatus?.length > 0) {
            <span class="pr-8 fs-16">{{ 'TOOLBAR.STATUS' | transloco }}</span>
          }
         <div class="mr-4 filtered-items flex items-center fs-16 fw-500" *ngIf="selectedStatus?.length > 0">
               <span *ngFor="let status of selectedStatus" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-2 pb-2 mr-16">
                  {{getStatusLabel(status) | titlecase}}
                  <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="cancelStatusFilter(status)"></mat-icon>
               </span>
         </div>
          @if (filterStartDate && filterEndDate) {
            <span class="pr-8 fs-16">{{ 'TOOLBAR.CREATED_DATE' | transloco }}</span>
          }
         <div class="mr-4 filtered-items flex items-center fs-16 fw-500" *ngIf="filterStartDate && filterEndDate">
            <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-2 pb-2 mr-16">
               {{ datePipe.transform(filterStartDate, 'dd MMM yyyy') }} - {{ datePipe.transform(filterEndDate, 'dd MMM yyyy') }}
               <span class="ml-8">
               <mat-icon svgIcon="close" class="cursor-pointer icon-sm" (click)="canceJobDateFilter()"></mat-icon>
               </span>
            </span>
         </div>
         <div class="flex flex-row items-center">
            <span *ngIf="selectedStatus?.length > 0 || selectedSchedule?.length > 0 || selectedRunbook?.length > 0 || (filterStartDate && filterEndDate)" class="flex justify-center items-center mat-subtitle-2 mb-0 fw-500 cursor-pointer warn-solid-fg" (click)="resetJobFilter()">
               {{ 'BUTTONS.CLEAR_ALL' | transloco }}
            </span>
         </div>
      </div>
    <mat-divider class="neutral-2 mt-12 mb-12 ml-4 mr-4"></mat-divider>
    <div *ngIf="!showLoader" class="flex flex-col border-radius route-table mb-16 mt-8 envt-jobs">
    <app-environment-table class="runbook-table" [ngClass]="{'disabled': showLoader}" (searchedResults)="searchedItems($event)" [displayColumns]="displayColumns" [showSkeletonLoader]="jobLoading" [initialDataSource]="dataJobs" [dataLoading]="jobLoading" [searchTerm]="searchTerm" [dataSourceLength]="true" [initialCreate]="data?.length === 0" (runbookData)="getJobsDetail()" (sorted)="resetPaginator()" (pageModify)="onTablePageChanged($event)" (pageChanged)="onPageChange($event)" pageName="environmentJobs"></app-environment-table>
    </div>

@if (showLoader) {
<div class="loader-section">
  <div class="runbook-group loader-header flex flex-col p-16">
    <div class="flex flex-row">
      @for (tableColumn of displayColumns; track tableColumn?.key) {
        <div class="loader-style">
          <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
        </div>
      }
    </div>
  </div>

  @for (item of [1, 2, 3]; track $index) {
    <div class="w-100-percent">
    <div class="runbook-group flex flex-col p-16">
      <div class="flex flex-row">
        @for (tableColumn of displayColumns; track tableColumn?.key) {
          <div class="loader-style">
            <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        }
      </div>
    </div>
    </div>
  }
</div>
}
